// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1z6L3","colBig":"styles_colBig__3v7Zv","colSmall":"styles_colSmall__3VrV1","shopifyNameWrapper":"styles_shopifyNameWrapper__S8C7s"};